import { Injectable } from '@angular/core';
import { Http } from '@angular/http';

import 'rxjs/add/operator/map';

const newURL: string = 'https://api.foursquare.com/v2/venues/search?oauth_token=FJ5LQGC5RM5GNN3VFFOSBUQIBZGMDWSKELDL4AG5EBUJNPE0&v=20170717&limit=50&ll=';
@Injectable()
export class FoursquareService {

    constructor(public http: Http) {
        this.http = http;
    }

    foursquareGet(data) {
        return this.http.get(newURL + data).map(res => res.json());
    }
}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/_services/foursquare.service.ts